export enum EPageType {
  user = 'user',
  user_follow = 'user_follow',
  user_topic = 'user_topic',
  hashtag = 'hashtag',
  article = 'article',
  video = 'video',
  feed = 'feed',
  poi = 'poi',
  experience = 'experience',
  experience_article = 'experience_article',
  experience_ugc = 'experience_article_ugc',
  discover = 'discover',
  search_sug = 'search_sug',
}

export const IMMERSIVE_POST_MODAL_NAME = 'article-immersive-post-modal';
export const DETAIL_POST_MODAL_NAME = 'article-detail-post-modal';

export const PageTypeUtils = {
  getPageTypeFromPathname: (pathname: string): EPageType | null => {
    if (pathname.startsWith('/discover/')) {
      return EPageType.discover;
    }
    if (pathname.startsWith('/experience/')) {
      return EPageType.experience;
    }
    if (pathname.startsWith('/feed')) {
      return EPageType.feed;
    }
    if (pathname.startsWith('/poi')) {
      return EPageType.poi;
    }
    if (pathname.startsWith('/topic')) {
      return EPageType.hashtag;
    }
    if (pathname.match(/^\/[^\/]+\/follow/)) {
      return EPageType.user_follow;
    }
    if (pathname.match(/^\/[^\/]+\/topic/)) {
      return EPageType.user_topic;
    }
    if (pathname.match(/^\/search\/sug/)) {
      return EPageType.search_sug;
    }

    // legacy article-i
    if (pathname.match(/^\/article\/i\d+/)) {
      return EPageType.article;
    }

    // legacy user-share
    if (pathname.match(/^\/user\/\d+\/share/)) {
      return EPageType.user;
    }

    const segmentCount = pathname.split('/').filter(Boolean).length;
    if (segmentCount === 1) {
      return EPageType.user;
    }
    if (segmentCount === 2) {
      return EPageType.article;
    }
    return null;
  },
};
